import * as React from 'react'
import { FieldProps } from 'formik'
import { Textarea as StyledTextarea } from '$views/components/Textarea'
import { Block, Division } from '$views/components'
import { ErrorText } from '$views/components/Input'
import { Text } from '../Text'

interface Props {
  label: string
  type: string
  placeholder?: string
  onBlur: () => void
  hasLine?: boolean
  maxLength?: number
  maxLengthLabel?: number
}

export const Textarea: React.SFC<Props & FieldProps<any>> = ({ field, form, label, placeholder, onBlur, ...props }) => {
  const getMaxLength = props.maxLength ? props.maxLength : undefined

  return (
    <>
      <StyledTextarea
        {...field}
        placeholder={placeholder}
        onBlur={onBlur}
        name={field.name}
        label={label}
        hasLine={props.hasLine}
        maxLength={getMaxLength}
      />
      {props.maxLengthLabel && (
        <Block flex justify="end">
          <Text
            menu
            color={field.value.length > props.maxLengthLabel ? 'darkPink' : 'darkGrey'}
            weight="medium"
          >{`${field.value.length}`}</Text>
          <Text menu marginRight="base" color="darkGrey" weight="medium">{`/${props.maxLengthLabel}`}</Text>
        </Block>
      )}
      {form.touched[field.name] && form.errors[field.name] && (
        <>
          <ErrorText caption error>
            {form.errors[field.name]}
          </ErrorText>
          <Division color="darkPink" />
        </>
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Forms/Textarea.tsx